import heroImage from './hero.jpg'

export { heroImage }